"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M10.5 7.2a.6.6 0 01.6-.6h1.8a.6.6 0 01.6.6v3.6h1.959a.3.3 0 01.208.516l-3.448 3.336a.3.3 0 01-.417.001l-3.466-3.337a.3.3 0 01.208-.516H10.5V7.2zM16.8 16.2H7.2v1.2h9.6v-1.2z" }), "Downloads");
//# sourceMappingURL=Downloads.js.map